import React from 'react';

import VideoPlayer from '@components/Gui/VideoPlayer';
import StyleVariables from '@components/Gui/StyleVariables';

import Modal from 'antd/lib/modal/Modal';

const ModalVideo = ({ video, onClose, zIndex = StyleVariables.ZIndexFullScreenPreview }) => {
    return (
        <Modal open onCancel={onClose} footer={null} width="92vw" zIndex={zIndex}>
            <VideoPlayer document={video} width="90vw" height="80vh" />
        </Modal>
    );
};

export default ModalVideo;
